
import RequestAbstract from "../abstract";

export default class FiltersBanks extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/filters-banks";
    }
}

